module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/241-st-vincent-and-the-grenadines-2633229fa224a0c038c662f629c282de.svg";